import React from "react";
import { makeStyles } from "tss-react/mui";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import {
  ExpandMore,
  HelpOutlined,
  CheckCircle,
  Cancel,
} from "@mui/icons-material";

type Alert = Record<"title" | "description", string>;
type Variant = "success" | "info" | "error";

interface ApprovalDetailsListProps {
  variant: Variant;
  alerts: Alert[];
}

const VARIANT_TITLES: Record<Variant, string> = {
  success: "Sucesso",
  info: "Analisar",
  error: "Inconsistências",
};

const VARIANT_ICONS: Record<Variant, React.ReactNode> = {
  success: <CheckCircle color="primary" fontSize="small" />,
  info: <HelpOutlined fontSize="small" />,
  error: <Cancel color="error" fontSize="small" />,
};

const useStyles = makeStyles()((theme) => ({
  errorText: {
    color: theme.palette.error.main,
    marginBottom: theme.spacing(2),
  },
  infoText: {
    color: theme.palette.warning.main,
    marginBottom: theme.spacing(2),
  },
  successText: {
    color: theme.palette.primary.dark,
    marginBottom: theme.spacing(2),
  },
  iconWrapper: {
    color: theme.palette.warning.main,
    "& > svg": {
      marginRight: theme.spacing(1),
    },
  },
}));

const ApprovalDetailsList = ({ variant, alerts }: ApprovalDetailsListProps) => {
  const { classes } = useStyles();

  return (
    <>
      <Typography className={classes[`${variant}Text`]} variant="subtitle1">
        {VARIANT_TITLES[variant]}
      </Typography>
      {alerts.map(({ title, description }) => (
        <Accordion key={title}>
          <AccordionSummary expandIcon={<ExpandMore />}>
            <div className={classes.iconWrapper}>{VARIANT_ICONS[variant]}</div>
            <Typography variant="body1" component="p" color="textPrimary">
              {title}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body1">{description}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
};

export default ApprovalDetailsList;
